import { ModuleBase } from '../../shared/modules';
import { routes } from '../auth/routes';

export class AuthModule extends ModuleBase {
  constructor() {
    super({ routes });
  }
}
